<!-- Просмотр фильтра -->
<ng-container
    *ngIf="!formFilter.isOpenFilter && formFilter.isFilterSet && (formFilterFieldsService.isInitForm$ | async) === true"
>
    <div class="filled-filter" (click)="formFilter.isOpenFilter = true">
        <div class="filter-chips">
            <div
                class="filter-shown-chips"
                (click)="$event.stopPropagation()"
                appOrganizeChips
                (chipsHidden)="chipsHidden = $event"
            >
                <ng-container *ngFor="let item of formFilterFieldsService.entityGrid">
                    <ng-container
                        *ngIf="
                            formFilterFieldsService.fieldGrid[item.name] &&
                            formFilterFieldsService.fieldGrid[item.name].length &&
                            isSubFormData(formFilterFieldsService.fieldGrid[item.name])
                        "
                    >
                        <ng-container *ngFor="let field of formFilterFieldsService.fieldGrid[item.name]">
                            <mat-chip-row
                                *ngIf="isFieldData(formDynamic.get(field.name))"
                                (click)="formFilter.isOpenFilter = true"
                            >
                                <!-- Выводим иконку связи если фильтр по связи -->
                                <mat-icon
                                    class="link-icon"
                                    *ngIf="mbHasMatch(field.name, '|')"
                                    aria-hidden="true"
                                    fontSet="mdi"
                                    fontIcon="mdi-link-variant"
                                >
                                </mat-icon>
                                <span class="filter-field-title"
                                    >{{ field.title[appService.currentLanguage] }}&nbsp;</span
                                >
                                <span [fuiTooltip]="getValueItem(field, formDynamic)">
                                    {{ getValueItem(field, formDynamic) | truncate: 20 }}
                                </span>
                                <fui-button
                                    matChipRemove
                                    class="ml-2"
                                    (clickEvent)="clearField(formDynamic.get(field.name))"
                                    [title]="appService.language_dictionary.system_clear"
                                    borderRadius="circle"
                                    type="button-icon"
                                    icon="close"
                                    color="neutral"
                                    height="slim"
                                >
                                </fui-button>
                            </mat-chip-row>
                        </ng-container>
                    </ng-container>
                </ng-container>
            </div>
            <div class="filter-more-chips">
                <mat-chip-row class="more-chip" *ngIf="chipsHidden"> Еще: {{ chipsHidden }} </mat-chip-row>
            </div>
        </div>
        <div class="filter-panel" (click)="$event.stopPropagation()">
            <span class="filter-found">
                {{ appService.language_dictionary.search_found }}: {{ formFilter.recordsFound }}
            </span>
            <fui-button
                (clickEvent)="clickClear()"
                [label]="appService.language_dictionary.system_drop_all"
                height="slim"
                color="soft-outline"
                icon="close"
            >
            </fui-button>
            <ng-container [ngTemplateOutlet]="filterKebab"></ng-container>
        </div>
    </div>
</ng-container>

<!-- Форма фильтра -->
<ng-container *ngIf="formFilter.isOpenFilter">
    <div class="p-2">
        <h3>
            {{ appService.language_dictionary.search_criterion }}
        </h3>
        <ng-container *ngIf="(registersLoaded$ | async) === true">
            <app-form-filter-fields
                #formFilterFields
                [formDynamic]="formDynamic"
                [settingData]="settingData"
                [registers]="registers"
                class="block"
            ></app-form-filter-fields>
        </ng-container>
        <ng-container [ngTemplateOutlet]="filterAction"></ng-container>
    </div>
</ng-container>

<ng-template #filterAction>
    <div class="table-filter-container-button left-pager-button-container gap-x-[8px]">
        <fui-button
            (clickEvent)="clickSearch(!formFilter.isOpenFilter)"
            [label]="appService.language_dictionary.system_search"
            icon="magnify"
            color="soft"
            height="slim"
        >
        </fui-button>
        <fui-button
            (clickEvent)="clearCriteria()"
            [label]="appService.language_dictionary.search_clear_criteria"
            height="slim"
            color="soft-outline"
            icon="eraser"
        >
        </fui-button>
        <fui-button
            (clickEvent)="clickClear()"
            [label]="appService.language_dictionary.system_drop_all"
            height="slim"
            color="soft-outline"
            icon="close"
        >
        </fui-button>
        <ng-container [ngTemplateOutlet]="filterKebab"></ng-container>
    </div>
</ng-template>

<ng-template #filterKebab>
    <fui-button
        [cdkMenuTriggerFor]="menuFilter"
        [title]="appService.language_dictionary.system_actions"
        height="slim"
        color="soft-outline"
        type="button-icon"
        icon="dots-vertical"
        *ngIf="
            hideButtons?.menu?.setupFilter === false ||
            hideButtons?.menu?.save !== true ||
            (isMapButtonVisible && hideButtons?.menu?.map !== true)
        "
    >
    </fui-button>
    <ng-template #menuFilter>
        <div fuiMenu>
            <ng-container *ngIf="hideButtons?.menu?.setupFilter === false">
                <button fuiMenuItem (click)="setupFilterClicked.emit()">
                    <span>{{ appService.language_dictionary.system_setting_filter }}</span>
                </button>
            </ng-container>
            <ng-container *ngIf="hideButtons?.menu?.save !== true">
                <button fuiMenuItem (click)="tableForm.openFilterDialog()">
                    <span>{{ appService.language_dictionary.system_save }}</span>
                </button>
            </ng-container>
            <ng-container *ngIf="isMapButtonVisible && hideButtons?.menu?.map !== true">
                <button fuiMenuItem (click)="tableForm.openAddLayer()">
                    <span>{{ appService.language_dictionary.system_save_layer }} </span>
                </button>
            </ng-container>
        </div>
    </ng-template>
</ng-template>
